import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import RefreshIcon from '@mui/icons-material/Refresh';
import HomeIcon from '@mui/icons-material/Home';

/**
 * Friendly error screen shown by ErrorBoundary when a component crashes.
 *
 * No stack traces are shown to the recruiter — errors are logged to console only.
 */
const PageErrorFallback = ({ onReset, title, message }) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    minHeight="60vh"
    p={3}
    role="alert"
    aria-live="assertive"
  >
    <Paper
      elevation={0}
      sx={{
        p: 6,
        textAlign: 'center',
        maxWidth: 480,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: 64, color: 'text.disabled', mb: 2 }} aria-hidden="true" />
      <Typography variant="h5" gutterBottom fontWeight="bold">
        {title || 'Something went wrong'}
      </Typography>
      <Typography color="text.secondary" mb={4}>
        {message ||
          'An unexpected error occurred on this page. Refreshing usually resolves it.'}
      </Typography>
      <Box display="flex" gap={2} justifyContent="center" flexWrap="wrap">
        <Button
          variant="contained"
          startIcon={<RefreshIcon />}
          onClick={() => window.location.reload()}
        >
          Refresh page
        </Button>
        {onReset && (
          <Button variant="outlined" onClick={onReset}>
            Try again
          </Button>
        )}
        <Button
          variant="text"
          startIcon={<HomeIcon />}
          onClick={() => { window.location.href = '/dashboard'; }}
        >
          Go to Dashboard
        </Button>
      </Box>
    </Paper>
  </Box>
);

export default PageErrorFallback;
